import classNames from 'classnames';
import React, { FC, PropsWithChildren } from 'react';

import useStyles from '../styles';

export const HeaderIcon: FC<PropsWithChildren> = ({ children }) => {
  const classes = useStyles();
  return <div className={classes.headerIcon}>{children}</div>;
};

export interface DrawerHeaderProps {
  className?: string;
  /**
   * Separates the header from the content scrolling beneath it. Draws a 1px
   * `gray200` rule along the bottom edge — not a drop shadow, despite the
   * name. Consumers had been passing this since the component was written,
   * but until AXHE-4405 it rendered nothing at all: the prop was forwarded to
   * a `useStyles` that takes no props.
   */
  showShadow?: boolean;
}

export const DrawerHeader: FC<PropsWithChildren<DrawerHeaderProps>> = ({ children, className, showShadow = false }) => {
  const classes = useStyles();

  return (
    <div className={classNames(classes.drawerHeader, { [classes.drawerHeaderDivider]: showShadow }, className)}>
      {children}
    </div>
  );
};
